document.addEventListener('click', function(e) {
  const btn = e.target.closest('button.hero-cta');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // Buscar o variant ID selecionado
  const variantInput = document.querySelector('#selected-variant, input[name="id"]');
  const variantId = variantInput ? variantInput.value : null;
  if (!variantId) return;

  // Imagem do produto
  const productImg = document.querySelector('.product-grid-desktop .grid-image img, .carousel-slide-mobile img');
  const imgSrc = productImg ? productImg.src : null;

  // Posição do botão
  const btnRect = btn.getBoundingClientRect();

  // Ícone do carrinho
  const cartIcon = document.querySelector('a[href="/cart"]');
  if (!cartIcon) return;
  const cartRect = cartIcon.getBoundingClientRect();

  // Adicionar ao carrinho via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(() => {

    // Atualizar contador do carrinho
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counters = document.querySelectorAll(
          '.cart-count, .cart-item-count, #cart-count, #CartCount, ' +
          '.header__cart-count, [data-cart-count], .cart-bubble, ' +
          '.cart__count, .cart-count-bubble, span.count'
        );
        counters.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });

    // Criar elemento voador
    const flyer = document.createElement('div');
    if (imgSrc) {
      flyer.style.backgroundImage = `url(${imgSrc})`;
    } else {
      flyer.style.background = '#fff';
    }

    flyer.style.position = 'fixed';
    flyer.style.width = '40px';
    flyer.style.height = '40px';
    flyer.style.borderRadius = '50%';
    flyer.style.backgroundSize = 'cover';
    flyer.style.backgroundPosition = 'center';
    flyer.style.zIndex = '9999';
    flyer.style.pointerEvents = 'none';
    flyer.style.left = (btnRect.left + btnRect.width / 2 - 20) + 'px';
    flyer.style.top = (btnRect.top + btnRect.height / 2 - 20) + 'px';
    flyer.style.opacity = '1';
    flyer.style.transition = 'none';

    document.body.appendChild(flyer);

    // Animar até ao ícone do carrinho
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        flyer.style.transition = 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        flyer.style.left = (cartRect.left + cartRect.width / 2 - 20) + 'px';
        flyer.style.top = (cartRect.top + cartRect.height / 2 - 20) + 'px';
        flyer.style.opacity = '0';
        flyer.style.transform = 'scale(0.2)';
      });
    });

    // Ícone pulsa quando a bolinha chega
    setTimeout(() => {
      flyer.remove();
      cartIcon.classList.add('cart-pulse');
      setTimeout(() => cartIcon.classList.remove('cart-pulse'), 1000);
    }, 850);

  })
  .catch(err => console.error('Erro ao adicionar ao carrinho:', err));
});
